import React from 'react'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { LayoutCardsColumns } from '../Retencion.styles'

const IndividualScore = ({ label, score, spaceBetween = true }) => {
    if (score == null || score <= 0) return null

    return (
        <div data-testid="individual-score" className={`containerLabel gap-10 ${spaceBetween ? 'space-between' : ''}`}>
            <span className="label">{label}:</span>
            <div className="label-status">{score}</div>
        </div>
    )
}

const ScoreUserInfo = ({ loading, data }) => {
    if (loading) return (
        <>
            <SkeletonLoader width='210px' height='20px' count={1} />
            <SkeletonLoader width='170px' height='20px' count={1} />
            <SkeletonLoader width='220px' height='20px' count={2} />
            <SkeletonLoader width='200px' height='20px' count={3} />
            <SkeletonLoader width='220px' height='20px' count={2} />
        </>
    )

    return (
        <LayoutCardsColumns>
            <IndividualScore label="Score total" spaceBetween={false} score={data.score_users} />
            <div className="containerLabel gap-10 no-flex">
                <span className="label green">Score detallado:</span>
                <IndividualScore label="Inventario historico" score={data.score_total_publications} />
                <IndividualScore label="Inventario activo" score={data.score_active} />
                <IndividualScore label="Destacados comprados" score={data.score_highlighted} />
                <IndividualScore label="Publicacion ultimos 3 meses" score={data.last_three_months_properties} />
                <IndividualScore label="Completitud de perfil" score={data.score_profile_completeness} />
                <IndividualScore label="Promedio de publicación" score={data.avg_properties_score} />
                <IndividualScore label="Interacción con panel" score={data.score_internal_panel_events} />
            </div>
        </LayoutCardsColumns>
    )
}

export default ScoreUserInfo